import { render, staticRenderFns } from "./queryDetail.vue?vue&type=template&id=70c41ce8&scoped=true"
import script from "./queryDetail.vue?vue&type=script&lang=js"
export * from "./queryDetail.vue?vue&type=script&lang=js"
import style0 from "./queryDetail.vue?vue&type=style&index=0&id=70c41ce8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c41ce8",
  null
  
)

export default component.exports